export const ERROR_MAP = {
  401: {
    INVALID_CREDS: 'Invalid credentials.',
  },
};
